// import classNames from "../../utilities/ClassNames";
import classNames from "utilities/ClassNames";

const TabsMenuItem = ({ isSelected, name, onClickHandler }: any) => {
  return (
    <div
      className={classNames(
        isSelected ? "border-b-green border-b-4" : "",
      )}
    >
      <div
        onClick={onClickHandler}
        className="cursor-pointer font-bold w-full h-full pb-1 px-1"
      >
        {name}
      </div>
    </div>
  );
};

const TabsMenu = ({ tabs }: any) => {
  return (
    <div className="flex gap-3">
      {tabs.map((single: any, key: number) => {
        return <TabsMenuItem key={key} isSelected={single.isSelected} name={single.name} onClickHandler={single.onClickHandler} />;
      })}
    </div>
  );
};

export default TabsMenu;